import React, { useState, useEffect } from "react";
import { UiComponents } from "@simulanisindia/ui";
import InfiniteScroll from "react-infinite-scroll-component";
import { EditIcon } from "../../Assets/Icons";
import { useNavigate } from "react-router-dom";
import apiClient from "../../apiClient";
import { SSO_URL } from "../../env";
import { GET_ALL_SUBSCRIPTION_LIST } from "../../apiClient/apiEndpoints";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import InvoiceSkeleton, { generateInvoiceSkeletonRows } from "../../Skeleton/InvoiceSkeleton";
import { formatRupees } from "../../Utils/common";
import NoDataFound from "../NoDataFound/NoDataFound";

const tableHeadersList = [
  { title: "Customer Info", className: "text-start" },
  { title: "Amounts", className: "text-start" },
  { title: "Issued Date", className: "text-start" },
  { title: "Status", className: "text-start" },
  { title: "In Due", className: "text-start" },
  { title: "Simulanis Invoice ID", className: "text-start" },
];

const InvoiceTable = ({ list, hasMore, handleLoadMoreList }) => {
  const { Table } = UiComponents;
  const tableClass = "table-striped table-bordered";

  const [tableData, setTableData] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    let optimizedTable = list.map((item) => {
      return {
        orgName: item.group.name,
        email: null,
        invoiceId: " ",
        amount: Number(item.amount),
        dueAmount: "",
        issuedDate: moment(item.start).format("LL"),
        status: " ",
        expired: item.expired,
        expiryDate: new Date(item.end),
        inDue: " ",
        simulanisInvoiceId: item.data.invoice,
        subscriptionId: item.uuid,
        groupId: item.group.uuid,
      };
    });

    setTableData(optimizedTable);
  }, [list]);

  const handleEditSubscription = (groupId, subscriptionId) => {
    navigate(`/organization/manage/subscription/plans/${groupId}/${subscriptionId}`);
  };

  const loadMoreData = () => {
    handleLoadMoreList();
  };

  const tableRowsList = tableData.map((invoice) => {
    let inDueClass = "";
    if (invoice.inDue === "Expired") {
      inDueClass = "expired";
    } else if (invoice.inDue.includes("days")) {
      const days = parseInt(invoice.inDue.split(" ")[0]);
      if (days < 5) {
        inDueClass = "danger";
      } else {
        inDueClass = "warning";
      }
    } else if (invoice.inDue.includes("month")) {
      inDueClass = "success";
    }

    return {
      cellData: [
        {
          value: (
            <>
              <p>{invoice.orgName}</p> <p className="orginvoicemail">{invoice.email}</p>
            </>
          ),
          className: "text-start",
        },
        {
          value: (
            <>
              <p>{formatRupees(invoice.amount)}</p>
              {invoice.dueAmount > 0 && <p className="dueamount">₹ {invoice.dueAmount.toLocaleString()} INR Due</p>}
            </>
          ),
          className: "text-start",
        },
        { value: invoice.issuedDate, className: "text-start" },
        {
          value: (
            <>
              <p className="duedate">
                <span className={invoice.expired ? "inactive" : "active"}> </span>
                {invoice.expired}
              </p>
              <p className="enddate">Ends {moment(invoice.expiryDate).format("LL")}</p>
            </>
          ),
          className: "text-start",
        },
        {
          value: (
            <>
              <p className="induedate">
                <span className={inDueClass}></span> {invoice.inDue}
              </p>
            </>
          ),
          className: "text-start",
        },
        {
          value: (
            <>
              {" "}
              <span onClick={() => handleEditSubscription(invoice.groupId, invoice.subscriptionId)}>
                {" "}
                {invoice.simulanisInvoiceId}
                {" "}
                <span style={{cursor:"pointer"}}>
                  <EditIcon />
                </span>{" "}
              </span>{" "}
            </>
          ),
          className: "text-start",
        },
      ],
    };
  });

  return (
    <>
      <div id="scrollableDivGroups" style={{ height: "100%", overflow: "auto" }} className="scrollable-container">
        <InfiniteScroll
          scrollThreshold={0.7}
          dataLength={list.length}
          next={() => loadMoreData()}
          hasMore={hasMore}
           loader={<Table tableClass={tableClass} tableHeaders={[]} tableRows={generateInvoiceSkeletonRows(5)} />}

          scrollableTarget="scrollableDivGroups"
        >
          {tableRowsList.length > 0 ?
            <Table tableClass={tableClass} tableHeaders={tableHeadersList} tableRows={tableRowsList} />
            :
            <NoDataFound  text="No invoice found." />
          }

        </InfiniteScroll>
      </div>
    </>
  );
};

export default InvoiceTable;